export default __webpack_public_path__ + "static/media/whatsapp.df14f4fc.svg";